module.exports = __webpack_public_path__ + "img/test_qrcode.5c386cc2.svg";